import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import SimpleModal from 'components/SimpleModal';
import { useDisconnectMyCalendar } from './hooks/useDisconnectMyCalendar';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DisconnectConfirmationModal(_ref) {
  var provider = _ref.provider,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDisconnectMyCalen = useDisconnectMyCalendar(),
    disconnectMyCalendar = _useDisconnectMyCalen.disconnectMyCalendar,
    isLoading = _useDisconnectMyCalen.isLoading;
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "wide",
    title: t(provider === 'google' ? 'modal_disconnect_calendar_google_title' : 'modal_disconnect_calendar_microsoft_title'),
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx("p", {
        children: t('modal_disconnect_calendar_message_1')
      }), /*#__PURE__*/_jsx("p", {
        children: t('modal_disconnect_calendar_message_2')
      })]
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isLoading
    }, {
      isLoading: isLoading,
      label: t('actions_disconnect'),
      onClick: function () {
        var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return disconnectMyCalendar(provider);
              case 1:
                onClose();
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onClick() {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }(),
      variant: 'primary'
    }],
    onClose: onClose
  });
}
export default DisconnectConfirmationModal;